import projects from './projects.js';
import navigator from './navigator.js';
import stakes from './stakes.js';
import indicators from './indicators.js';
import scenarios from './scenarios.js';
import fishbone from './fishbone.js';
import risks from './risks.js';
import watch from './watch.js';
import profile from './profile.js';
import disabled from './disabled.js';

export default {
	projects,
	navigator,
	stakes,
	indicators,
	scenarios,
	fishbone,
	risks,
	watch,
	profile,
	disabled
};
